export default "<div [innerHTML]=\"grammarLessonBody\" class=\"gl-data-container gl_{{options.data.id}}\" ></div>\n";